module Omni.ResortMap {
    ngModule.controller('RoomController',
        ['ResortProvider', '$scope', '$state', '$stateParams', '$timeout',
            function (ResortProvider, $scope, $state, $stateParams, $timeout) {

                $scope.location = ResortProvider.getLocation($stateParams.id);
                $scope.showBackButton = true;

                $scope.floor = $scope.location.floor[$stateParams.floorId];
                $scope.room = null;
                angular.forEach($scope.floor.room, function (value, index) {
                    if (index == $stateParams.roomId) {
                        $scope.room = value;
                    }
                });

                $scope.partialIndex = 0;
                $scope.partials = $scope.room.partial;
                $scope.partial = $scope.partials[$scope.partialIndex];
                $scope.layouts = $scope.partial.layout;

                $scope.showPartialSelector = function () {
                    return $scope.partials.length > 1;
                };

                $scope.roomVideoToggle = function () {
                    if ($state.current.name !== 'room.video') {
                        $state.go('room.video');
                    } else {
                        $state.go('room');
                    }
                };
            }
        ]);
}
